import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
/*[2/24/22, PC_SH_19, Priyanka D]*/
class ShippingStore extends EventEmitter {
    /*[2/24/22, PC_SH_20, Priyanka D]*/
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleShipping = (action) => {
        let ShippingAccessToken = "";
        let RecipientData = "";
        let UpdatetrackNum = "";
        let PrintLabel = "";
        switch (action.action.type) {
            case "ShippingAccessToken": {
                
                this.ShippingAccessToken = action.action.response;
                this.emit('ShippingAccessToken');
                break;
            }
            case "RecipientData": {
                
                this.RecipientData = action.action.response;
                this.emit('RecipientData');
                break;
            }
            case "AccesstokenRes": {
                
                this.AccesstokenRes = action.action.response;
                this.emit('AccesstokenRes');
                break;
            }
            case "SubmitClickData": {
                
                this.SubmitClickData = action.action.response;
                this.emit('SubmitClickData');
                break;
            }
            case "UpdatetrackNum": {
                
                this.UpdatetrackNum = action.action.response;
                this.emit('UpdatetrackNum');
                break;
            }
            case "PrintLabel": {
                
                this.PrintLabel = action.action.response;
                this.emit('PrintLabel');
                break;
            }
            case "SHIPPING_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "SHIPPING_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "SHIPPING_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
        }
    }
}
const objShippingStore = new ShippingStore;
// Dispatcher code
Dispatcher.register(objShippingStore.handleShipping.bind(objShippingStore));
export default objShippingStore;